import React from 'react';

interface UserIconBlueProps {
  className?: string;
  size?: number;
}

const UserIconBlue: React.FC<UserIconBlueProps> = ({ className = '', size = 48 }) => (
  <svg 
    className={className} 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="10" fill="#3B82F6"/>
    <path 
      d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4z" 
      fill="white"
    />
    <path 
      d="M12 14c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" 
      fill="white"
    />
  </svg>
);

export default UserIconBlue;